import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=497a43bf&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497a43bf')) {
      api.createRecord('497a43bf', component.options)
    } else {
      api.reload('497a43bf', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=497a43bf&", function () {
      api.rerender('497a43bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/comp/childrenage.vue"
export default component.exports